import React, { useContext, useEffect, useState } from 'react'
import './navbar.css'
import { Link } from 'react-router-dom'
import { AuthContext } from '../../../context/Authcontext'
import logoNavBar from '../../../assets/img/LOGO-TPA-BLANCO.png'
import { ModalNavbar } from '../../feedback/modal/ModalNavbar'
import { PopOver } from '../PopOver/PopOver'

export const Navbar = () => {



    //? Limitacion del modal en mobile 

    const [isMobile, setIsMobile] = useState(window.innerWidth > 768)

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth > 768)
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize)
    }, [])



    const { userInfo } = useContext(AuthContext)
    const [initialLetter, setInitialLetter] = useState()

    useEffect(() => {
        if (userInfo) {
            const initial = userInfo.name.charAt(0).toUpperCase()
            //console.log('initial: ', initial)
            setInitialLetter(initial)
        }
    }, [userInfo])

    const [showModal, setshowModal] = useState(false)

    const toggleModal = () => {
        setshowModal(!showModal)
    }





    return (

        <header className="header-nav">


            <nav>

                <div className="user-nav">



                    {/* <Link to="/biblioteca"><i className="bi bi-house-fill bi-house-class"></i></Link> */}
                    <div className="logo-mobile">

                        <Link to="/biblioteca"><img className="logo-nav-tpa" src={logoNavBar} alt="logo" /></Link>
                        <span className='span-logo-mobile'>Sala Virtual</span>
                    </div>




                    <div className="user-profile" onClick={() => { toggleModal() }}>
                        {userInfo && <p className="FirstName FN-responsive">Hola {userInfo.name}!</p>}
                        <div className="initials-container">
                            <span className="initials">{initialLetter}</span>
                        </div>
                    </div>
                </div>

            </nav>

            {isMobile
                ?
                <ModalNavbar showModal={showModal} toggleModal={toggleModal} />
                :
                null
            }

        </header>

    )
}
